import { useEffect } from "react";

import { MainPath } from "Constants/constants";
import { useFeatureToggle } from "Store/featureToggles/featureToggleHooks";
import { FeatureToggle } from "Store/featureToggles/featureToggleTypes";
import { ReduxState } from "Store/rootReducer";
import { CustomerStatus } from "Store/userIdentification/userIdentificationInterfaces";
import { isDefined } from "Utils/functions";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { customerStatusToIndex } from "../utils/customerStatusMapper";
import { isUnwanted } from "../utils/isUnwanted";

let timer: ReturnType<typeof setTimeout> | undefined;
const debounce = (f: () => any): void => {
  if (isDefined(timer)) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    f();
    timer = undefined;
  }, 300);
};

export const CheckPriceBlocker = (): null => {
  const enabled = useFeatureToggle(FeatureToggle.BI_8804);
  const history = useHistory();
  const user = useSelector((state: ReduxState) => state.userIdentification);

  const checkAndBlockNavigation = (): void => {
    if (!isDefined(user.current)) {
      return;
    }

    const to = history.location.pathname;

    if (
      isUnwanted(user.current.discountResponse.customerStatus) &&
      to.includes(MainPath.CHECK_PRICE)
    ) {
      history.push(
        `/${MainPath.UNEXPECTED}?status=${customerStatusToIndex(
          user.current.discountResponse.customerStatus as CustomerStatus,
        )}`,
      );
    }
  };

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (isDefined(user.current)) {
      debounce(checkAndBlockNavigation);
    }

    const listener = history.listen(() => {
      debounce(checkAndBlockNavigation);
    });

    return () => {
      listener(); // unregisters listener
    };
  }, [user.current, enabled]);

  return null;
};
